import DeleteIcon from '@mui/icons-material/Delete';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const deleteMessage = defineMessage({
  id: 'common.actions.delete',
  defaultMessage: 'Eliminar',
});

interface FragmentViewDeleteMenuItemProps {
  /** Called when the user requests delete (e.g. close menu and open confirm dialog). */
  onAction: () => void;
}

/**
 * Overflow menu item that requests opening the fragment delete confirmation dialog.
 */
export function FragmentViewDeleteMenuItem({ onAction }: FragmentViewDeleteMenuItemProps) {
  return (
    <MenuItem onClick={onAction} sx={{ color: 'error.main' }}>
      <ListItemIcon sx={{ color: 'inherit' }}>
        <DeleteIcon fontSize="small" />
      </ListItemIcon>
      <ListItemText>
        <FormattedMessage {...deleteMessage} />
      </ListItemText>
    </MenuItem>
  );
}
